enum TwsParametersConstants {
  TYPE_VIEW_RESULTS_LAB = '1',
  TYPE_VIEW_RESULTS_N_LAB = '2',
  ALLOW_TO_CREATE_USER = '5',
  TYPE_VIEW_RESULTS = '6',
  ONLY_PRESC_EXAMS_APPROVED = '7',
  ONLY_RESULTS_CO_PATIENT = '8',
  CONSULT_RESULTS_PDF = '9',
  DATA_MEDIC_LOGADO = '10',
  VIEW_HORA_COLUMN = '11',
  VIEW_MEDIC_EXTERN = '12',
  PACS_INTEGRATION_TYPE = '13',
  VIEW_EXAMS_SECTOR = '14',
  VIEW_ONLY_ATEND_EXTERN = '15',
  ESTAB_EXTERN = '16',
  VIEW_ATEND_PAC_INTERN = '17',
  UTIL_AGRUP_PERSON_RESULTS = '18',
  VIEW_SECTOR_PAC_INTERN = '19',
}

export default TwsParametersConstants;
